import React from 'react';
import { FaUsers, FaBookOpen } from 'react-icons/fa';
import {
  ConnectedToolsSection,
  SectionHeading,
  ConnectedTools,
  ConnectedToolLink,
  ConnectedToolIcon,
} from './Tools.styles';
const Tools = () => {
  return (
    <ConnectedToolsSection>
      <SectionHeading>
        <p className="eyebrowHeader">Build a More Connected Safety Program</p>

        <h2>Keep Training, Forms, and Manuals Easier to Manage</h2>

        <p>
          Digital forms can work alongside other Yoda Safety Services tools to
          help your company keep workplace safety information more organized.
        </p>
      </SectionHeading>

      <ConnectedTools>
        <ConnectedToolLink to="/company-training">
          <ConnectedToolIcon>
            <FaUsers />
          </ConnectedToolIcon>

          <div>
            <span>Company Training</span>

            <h3>Track Employee Safety Training</h3>

            <p>
              Assign courses, monitor completion, and keep employee training
              records and certificates easier to access.
            </p>

            <strong>
              Explore Company Training
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>

        <ConnectedToolLink to="/safety-manuals">
          <ConnectedToolIcon>
            <FaBookOpen />
          </ConnectedToolIcon>

          <div>
            <span>Safety Manuals</span>

            <h3>Keep Important Manuals Accessible</h3>

            <p>
              Give your team access to workplace safety manuals and important
              documentation in one place.
            </p>

            <strong>
              Explore Safety Manuals
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>
      </ConnectedTools>
    </ConnectedToolsSection>
  );
};

export default Tools;
